module.exports = __webpack_public_path__ + "img/collect_title.9a99b609.svg";